<template>
<!--	<form method="post" action="https://clientzone.afrihost.com/en/api/of/fibre-injection" enctype='application/json' >-->
	<form method="post" action="https://clientzone.afrihost.com/en/api/of/fibre-injection" enctype='application/json' >
<!--		<input type="hidden" name="place[building_name]" :value="place.building_name" />-->
<!--		<input type="hidden" name="place[city]" :value="place.city" />-->
<!--		<input type="hidden" name="place[country_code]" :value="place.country_code" />-->
<!--		<input type="hidden" name="place[formatted_address]" :value="place.formatted_address" />-->
<!--		<input type="hidden" name="place[google_place_id]" :value="place.google_place_id" />-->
		<input type="hidden" name="place[latitude]" :value="place.latitude" />
		<input type="hidden" name="place[longitude]" :value="place.longitude" />
		<input type="hidden" name="product[id]" :value="productId" />
		<input type="hidden" name="is_preorder" :value="preOrder ? 1 : 0" />
		<button class="btn gradient-red" :disabled="!productId">{{ preOrder ? 'Pre-order' : 'Checkout' }}</button>
	</form>
</template>
<script>
	export default {
		props: ['place', 'productId', 'preOrder']
	}
</script>
